export default __webpack_public_path__ + "static/logo-4148329c39818cf1ad54b73e79ebe635.svg";